// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;

/*
render function
*/
import { arrangeColumnsRenderFunction } from 'js/arrangeColumnsService';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/arrangeColumnsService', () => import('js/arrangeColumnsService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "imports": [],
  "actions": {
    "render": {
      "method": "arrangeColumnsRenderFunction",
      "deps": "js/arrangeColumnsService"
    }
  },
  "lifecycleHooks": {
    "render": "render"
  },
  "onEvent": [],
  "data": {},
  "i18n": {},
  "_viewModelId": "ArrangeColumns",
  "_uniqueViewModelId": "ArrangeColumns",
  "ctx": {}
};

/*
define component
*/
const Component = createComponent(declViewModelJson, arrangeColumnsRenderFunction, undefined, ctxImportObj);
export default Component;